export const sortDate = (field, asc = true) => (a, b) => {
  const order = a[field] - b[field]
  return asc ? order : order * -1
}
